var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { bindActionCreators } from "redux";
import { IdLandingPageMessages } from "../../constants/IdLandingPageMessages";
import { IdPersistence } from "../../constants/IdPersistence";
import { eventsStore } from "../../events/eventsStore";
import { EventHandler, MessageHandler } from "../../utils/landing-page/utilLandingPage";
import { logLandingPages } from "../../utils/logging/logging";
import { PersistenceMode } from "../../utils/PersistenceMode";
import { utilTracking } from "../../utils/tracking/utilTracking";
import { utilPersistence } from "../../utils/utilPersistence";
import { IdStatusClientGateway } from "../client-gateway/IdStatusClientGateway";
import { actionEnvSelect } from "../env-select/actionEnvSelect";
import { actionGameTrackingUpdateClientFunnel } from "../game-tracking/actionGameTracking";
import { IdGameTrackingClientFunnelState } from "../game-tracking/game-funnel/IdGameTrackingClientFunnelState";
import { LandingPageInitProps } from "./LandingPageInitProps";
var ExternalLandingPage = /** @class */ (function () {
    function ExternalLandingPage() {
        var _this = this;
        this.setup = function () {
            if (eventsStore.storeUpdate$) {
                _this.subscription = eventsStore.storeUpdate$.subscribe(_this.onStoreUpdate);
            }
        };
        this.tryAutoLogin = function () {
            if (_this.init) {
                _this.messageHandler.sendMessage(IdLandingPageMessages.GetAutologinData, _this.onAutoLogInResponse);
            }
        };
        this.getReferrer = function () {
            if (_this.init) {
                _this.messageHandler.sendMessage(IdLandingPageMessages.ggsGetReferrer, function (res) {
                    logLandingPages("Referrer:", res);
                    utilTracking.referrer = res;
                });
            }
        };
        this.onLogin = function (playerId, gnip) {
            if (_this.init) {
                var authData = _this.getAuthData();
                _this.messageHandler.sendMessage(IdLandingPageMessages.GGSTrackEvent, "enteredclient", {
                    userId: gnip,
                });
                _this.messageHandler.sendMessage(IdLandingPageMessages.LoginComplete, {}, playerId, authData.instanceId, authData.networkId, authData.gameId);
            }
        };
        this.onRegistration = function (playerId) {
            if (_this.init) {
                var authData = _this.getAuthData();
                _this.messageHandler.sendMessage(IdLandingPageMessages.Register, {}, playerId, authData.instanceId, authData.networkId, authData.gameId);
            }
        };
        this.onLogout = function () {
            if (_this.init) {
                utilPersistence.setValue(IdPersistence.Credentials, {}, PersistenceMode.Write, true);
                _this.messageHandler.sendMessage(IdLandingPageMessages.Logout);
                _this.messageHandler.sendMessage(IdLandingPageMessages.RemoveAutologinData);
                _this.subscription.unsubscribe();
                _this.redirectToLP();
            }
        };
        this.onLoading = function () {
            if (_this.init) {
                _this.messageHandler.sendMessage(IdLandingPageMessages.Load);
            }
        };
        this.onLoadingComplete = function () {
            if (_this.init) {
                _this.messageHandler.sendMessage(IdLandingPageMessages.LoadComplete);
            }
        };
        this.redirectToLP = function () {
            if (_this.init) {
                _this.messageHandler.sendMessage(IdLandingPageMessages.ggsRedirectToLandingPage);
            }
        };
        this.onShopVisit = function () {
            if (_this.init) {
                _this.messageHandler.sendMessage(IdLandingPageMessages.GGSTrackEvent, "shop_visit", {
                    userId: _this.gnip(),
                });
            }
        };
        this.doAutoLogin = function () {
            _this.props.onLoginTracking(IdGameTrackingClientFunnelState.LOGIN_START);
            _this.onLoading();
            _this.tryAutoLogin();
        };
        this.onShopPurchaseComplete = function (isFirstPurchase, value, currency) {
            if (_this.init) {
                var message = isFirstPurchase ? "firstingamepurchase" : "purchase";
                _this.messageHandler.sendMessage(IdLandingPageMessages.GGSTrackEvent, message, {
                    currency: currency,
                    userId: _this.gnip(),
                    value: value,
                });
            }
        };
        this.onPlayerLevelUp = function (playerLevel) {
            if (_this.init) {
                _this.messageHandler.sendMessage(IdLandingPageMessages.GGSTrackEvent, "level" + playerLevel, { userId: _this.gnip() });
            }
        };
        this.mapDispatch = function (dispatch) {
            return bindActionCreators({
                onEnvSelect: actionEnvSelect,
                onLoginTracking: actionGameTrackingUpdateClientFunnel,
            }, dispatch);
        };
        this.mapState = function (state) { return state; };
        this.onAutoLogInResponse = function (res) {
            var authData = res;
            if (authData !== undefined) {
                utilPersistence.setValue(IdPersistence.Credentials, authData, PersistenceMode.Write, true);
                _this.onLoadingComplete();
                _this.onLogin(authData.playerId, _this.gnip());
                _this.props.onEnvSelect(IdStatusClientGateway.Approval);
                _this.props.onLoginTracking(IdGameTrackingClientFunnelState.LOGIN_END);
            }
            else {
                _this.redirectToLP();
            }
        };
        // gnip is uniq id combined with gameId networkId instanceId playerId for game integration.
        this.gnip = function () {
            var authData = _this.getAuthData();
            if (authData) {
                return authData.gameId + "-" + authData.networkId + "-" + authData.instanceId + "-" + authData.playerId;
            }
            return "";
        };
        this.getAuthData = function () {
            return utilPersistence.getValue(IdPersistence.Credentials, {});
        };
        this.onStoreUpdate = function (store) {
            var state = _this.mapState(store.getState());
            _this._props = __assign({}, state, _this.mapDispatch(store.dispatch));
        };
        var eventHandler = EventHandler();
        this.messageHandler = MessageHandler(eventHandler, LandingPageInitProps.trustedDomains, window.parent);
        this.messageHandler.register();
        this.init = true;
        this.mapDispatch = this.mapDispatch.bind(this);
        this.onStoreUpdate = this.onStoreUpdate.bind(this);
        this.onAutoLogInResponse = this.onAutoLogInResponse.bind(this);
    }
    Object.defineProperty(ExternalLandingPage.prototype, "props", {
        get: function () {
            return this._props;
        },
        enumerable: true,
        configurable: true
    });
    return ExternalLandingPage;
}());
export var landingPageMessageHandler = new ExternalLandingPage();



//////////////////
// WEBPACK FOOTER
// ./src/features/landing-page/landingPageMessageHandler.ts
// module id = 280
// module chunks = 3